module.exports = __webpack_public_path__ + "img/sub-menu.d97683f4.svg";